module.exports = function getResource (label, vars = []) {
    let resources = {
        month: 'Month',
        day: 'Day',
        year: 'Year'
    };
    return resources[label];
};
